



















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class AdminDrawer extends Vue {
  /* ------------------------------------
  => Local State Declaration
  ------------------------------------ */
  menuItems: any = [
    {
      icon: 'mdi-view-dashboard',
      title: 'Beranda',
      to: 'data'
    },
    {
      icon: 'mdi-account-key',
      title: 'Pengaturan Akses',
      to: 'user'
    }
  ];

  /* ------------------------------------
  => Methods
  ------------------------------------ */
  changeView(param: string): void {
    if (this.$route.query.show !== param) {
      this.$router.push(`/dashboard?show=${param}`);
    }
  }
}
